var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{staticClass:"mt-n8",attrs:{"fixed-tabs":"","dark":""}},[_c('v-tabs-slider',{attrs:{"color":"#FAD84B"}}),_c('v-tab',[_vm._v(" NEARBY ")]),_c('v-tab',[_vm._v(" MATCHES ")]),_c('v-tab',[_vm._v(" ALL ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }